<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
    </div>
    <div class="global-table-container">
      <a-button
        type="primary"
        style="margin-bottom:10px; margin-right:10px"
        @click="onCheck"
      >
        审核
      </a-button>
      <a-button
        style="margin-bottom:10px;"
        type="danger"
        @click="onDeleteAll"
      >
        删除
      </a-button>
      <span
        v-show="isShowError"
        class="errorMsg"
      >请至少选择一项</span>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="false"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <popconfirm-button
            text="删除"
            alert-title="确定删除?"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import {answerColumns} from '../data/index';
export default {
  data() {
    return {
      columns: answerColumns,
      data: [],
      loading: false,
      btnIsLoading: false,
      id: '',
      selectedRowKeys: [],
      isShowError: false,
    };
  },
  mounted() {
    this.id=this.$route.query.id;
    // 获取表格数据
    this.getTableData({id: this.id});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/comment/applyList', params);
      if (result.data.status===1) {
        this.loading = false;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            full_name: item.full_name,
            content: item.content,
            status: item.status,
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },

    async onDelete(record){
      let result = await this.$http.post('/comment/del', {id: record.id});
      if (result.data.status===1) {
        this.getTableData({id: this.id});
        this.$message.success('操作成功！');
      }
    },
    async onDeleteAll(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/comment/moreDel', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({ id: this.id});
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
      }
    },
    // 审核批量
    async onCheck(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/comment/moreCheck', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({ id: this.id});
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
  },
};
</script>
<style lang="scss" scoped>
.errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
</style>
